import { StoreApi } from 'zustand';

import createStoreWithDevtools from './createStoreWithDevTools';

type SimpleStoreConfig<State extends object, Actions extends object> = {
  name: string;
  initialState: State;
  actions: (set: StoreApi<State & Actions>['setState'], get: StoreApi<State & Actions>['getState']) => Actions;
};

export function createSimpleStore<State extends object, Actions extends object>(config: SimpleStoreConfig<State, Actions>) {
  const { name, initialState, actions } = config;

  return createStoreWithDevtools<State & Actions>(
    (set, get) => ({
      ...initialState,
      ...actions(set, get)
    }),
    name
  );
}
